import { Box, Button, Divider, Typography } from "@mui/material"
import CustomDialog from "components/Dialogs/MasterDialog"
import { CommonTexts, contentTexts } from "locale/es"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { deletePatientContentAction } from "redux/reducers/patientContentReducer"
import { AppColors } from "resources/AppColors"

function DeletePatientContentDialog({ isDashboardView }) {
  const { entityId } = useLocation().state

  const navigate = useNavigate()

  const dispatch = useDispatch()

  function handleOnConfirmDeletePatientContent() {
    dispatch(deletePatientContentAction(entityId))
    handleShowExitModal()
  };

  function handleShowExitModal() {
    if (isDashboardView) {
      navigate('/dades-del-participant', {
        state: { tabIndex: 2 }
      })
    } else {
      navigate('/contingut/patients')
    }
  }

  return (
    <CustomDialog
      title={contentTexts.DELETE_TITLE}
      show={true}
      handleShow={handleShowExitModal}
    >
      <Divider />
      <Box py={2} px={3} sx={{ minWidth: "50%" }}>
        <Typography variant="body">
          {contentTexts.DELETE_CONFIRM}
        </Typography>
      </Box>
      <Divider />
      <Box display="flex" justifyContent="flex-end" p={1}>
        <Button
          style={{ backgroundColor: AppColors.RED }}
          color="primary"
          variant="contained"
          onClick={handleOnConfirmDeletePatientContent}
        >
          {CommonTexts.DELETE}
        </Button>
      </Box>
    </CustomDialog>
  )
}

export default DeletePatientContentDialog